import { useQuery } from '@tanstack/react-query'

import { axios, ExtractFnReturnType, QueryConfig } from '@apps-common/lib'
import { IActivationServiceRequestModel } from '@apps-common/types/portal/service-request'

export const QUERY_GET_UNIT_ACTIVATION_BY_ID = (id?: number) => ['getUnitActivationById', id]

export const getUnitActivationById = async (id: number): Promise<IActivationServiceRequestModel> =>
  axios.get(`/UnitActivation/GetUnitActivationRequestById?requestId=${id}`).then((res) => res.data?.data)

type QueryFnType = typeof getUnitActivationById

type Props = {
  config?: QueryConfig<QueryFnType>
  id: number | undefined
}

export const useGetUnitActivationById = ({ config, id }: Props) =>
  useQuery<ExtractFnReturnType<QueryFnType>>({
    ...{ ...config, cacheTime: 0 },
    queryKey: QUERY_GET_UNIT_ACTIVATION_BY_ID(id),
    queryFn: () => getUnitActivationById(id || 0)
  })
